import { callApi } from '@local_modules/generic/fetch.js'

/**
 * @param {*} context
 * @param {String} context.showOrgId
 * @returns
 */
export async function loadData (context) {
  console.log('loadData', context)
  const accountingOrganisationId = context.accountingOrganisationId

  //
  const journalsValuesCall = callApi('/api/pg-financials/data/:accountingOrganisationId/pg-monthly-values/:monthFrom/:monthTo', { accountingOrganisationId })
  const tbValuesCall = callApi('/api/pg-financials/data/:accountingOrganisationId/pg-trial-balances-values/:monthFrom/:monthTo', { accountingOrganisationId })
  const ledgersValuesCall = callApi('/api/pg-financials/data/:accountingOrganisationId/pg-ledgers-values/:monthFrom/:monthTo', { accountingOrganisationId })

  const adjustmentsCall = callApi('/api/pg-financials/data/:accountingOrganisationId/pg-monthly-values-adjustments', { accountingOrganisationId })

  const [journalsValues, tbValues, ledgersValues, adjustments] = await Promise.all([
    journalsValuesCall,
    tbValuesCall,
    ledgersValuesCall,
    adjustmentsCall
  ])

  context.data = {
    journalsValues: journalsValues?.monthlyValues,
    tbValues,
    ledgersValues,
    adjustments
  }
}
